function SendDoc({ width, height, className }) {

  return (
    <svg id="send_doc" xmlns="http://www.w3.org/2000/svg" width={width} height={height} class={`MuiSvgIcon-root ${className}`} viewBox="0 0 24 24">
      <path id="Tracé_13995" data-name="Tracé 13995" d="M0,0H24V24H0Z" fill="none" />
      <path id="Tracé_13996" data-name="Tracé 13996" d="M14.59,2.59A2.006,2.006,0,0,0,13.17,2H6A2.006,2.006,0,0,0,4,4V20a2,2,0,0,0,1.99,2H18a2.006,2.006,0,0,0,2-2V8.83a1.966,1.966,0,0,0-.59-1.41L14.59,2.59ZM15,18H9a1,1,0,0,1,0-2h6a1,1,0,0,1,0,2Zm0-4H9a1,1,0,0,1,0-2h6a1,1,0,0,1,0,2ZM13,8V3.5L18.5,9H14A1,1,0,0,1,13,8Z" transform="translate(1.41 0.5)" fill="#5D75A8" />
      <g id="file_download_black_24dp_2_" data-name="file_download_black_24dp (2)" transform="translate(2.59 1.5)">
        <g id="Groupe_3536" data-name="Groupe 3536" transform="translate(0 0)">
          <path id="Tracé_14076" data-name="Tracé 14076" d="M8.751,5.155H7.385V.859A.862.862,0,0,0,6.526,0H3.088a.862.862,0,0,0-.859.859v4.3H.863a.862.862,0,0,0-.61,1.469L4.2,10.568a.856.856,0,0,0,1.212,0L9.353,6.625A.859.859,0,0,0,8.751,5.155Z" transform="translate(10.82 0) rotate(90)" fill="#fff" stroke="#5D75A8" strokeWidth="2" />
        </g>
      </g>
    </svg>)
}


export default SendDoc
